module.exports = __webpack_public_path__ + "85bfd9fd94f6c55d7e73cebb83ae7cd1.glb";